export enum ClientCutoutModalTabs {
    DEFAULT = 1,
    ORGANOGRAM,
    TAGS,
    VEHICLE
}